import mediaOptions from './mediaOptions.js'
export default factory

function factory(settings) {
  return {
    mediaOptions: mediaOptions(settings),
    log: console.log,
  }
}
